import { Routes } from '@angular/router';
import { securityGuardFn } from '@core/guards';
import { engancheCeroGuard } from '@enganche-cero/guards';


export const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./features/welcome/welcome.routes').then(r => r.welcomeRoutes),
    title: 'Página de Bienvenida'
  },
  {
    path: 'vendedor',
    loadChildren: () => import('./features/role/role.routes').then(r => r.roleRoutes)
  },
  {
    path: 'login',
    loadChildren: () => import('./features/login/login.routes').then(r => r.loginRoutes),
    title: 'Iniciar sesión'
  },
  {
    path: 'registro',
    loadChildren: () => import('./features/registro/registro.routes').then(r => r.registroRoutes),
    title: 'Registro'
  },
  {
    path: 'sms',
    loadChildren: () => import('./features/sms/sms.routes').then(r => r.smsRoutes),
    canActivate: [securityGuardFn],
    title: 'Sms'
  },
  {
    path: 'aviso-biometria',
    loadChildren: () => import('./features/biometricos/aviso-biometria/aviso-biometria.routes').then(r => r.avisoBiometriaRoutes),
    canActivate: [securityGuardFn],
    title: 'Aviso de biometría'
  },
  {
    path: 'biometria',
    loadChildren: () => import('./features/biometricos/biometria/biometria.routes').then(r => r.biometriaRoutes),
    canActivate: [securityGuardFn],
    title: 'Biometricos'
  },
  {
    path: 'cliente',
    loadChildren: () => import('./features/cliente/cliente.routes').then(r => r.clienteRoutes),
    // canActivate: [securityGuardFn],
    title: 'Formulario'
  },
  {
    path: 'email',
    loadChildren: () => import('./features/email/email/email.routes').then(r => r.emailRoutes),
    canActivate: [securityGuardFn],
    title: 'Insertar email'
  },
  {
    path: 'email-confirma',
    loadChildren: () => import('./features/email/email-confirmar/email-confirmar.routes').then(r => r.emailConfirmarRoutes),
    canActivate: [securityGuardFn],
    title: 'Confirmar email'
  },
  {
    path: 'nauphilus',
    loadChildren: () => import('./features/nauphilus/nauphilus.routes').then(r => r.nauphilusRoutes),
    canActivate: [securityGuardFn]
  },
  {
    path: 'equipos',
    loadChildren: () => import('./features/equipos/equipos/equipos.routes').then(r => r.equiposRoutes),
    canActivate: [securityGuardFn],
    title: 'Listado de equipos'
  },
  {
    path: 'detalle-producto',
    loadChildren: () => import('./features/equipos/detalle-producto/detalle-producto.routes').then(r => r.detalleProductoRoutes),
    canActivate: [securityGuardFn],
    title: 'Detalle del equipo'
  },
  {
    path: 'entrega-equipo',
    loadChildren: () => import('./features/entrega-equipo/direccion-entrega.routes').then(r => r.direccionEntregaRoutes),
    canActivate: [securityGuardFn],
    title: 'Entrega a domicilio'
  },
  {
    path: 'pago',
    loadChildren: () => import('./features/pago/pago.routes').then(r => r.pagoRoutes),
    title: 'Pago'
  },
  {
    path: 'enrolamiento',
    loadChildren: () => import('./features/enrolamiento/enrolamiento.routes').then(r => r.enrolamientoRoutes),
    title: 'Enrolando el equipo'
  },
  {
    path: 'aviso-cero-enganche',
    loadChildren: () => import('./features/enganche-cero/aviso-enganche-cero.routes').then(r => r.avisoEngancheCeroRoutes),
    canActivate: [engancheCeroGuard],
    title: 'Enganche cero'
  },
  {
    path: 'entrega',
    loadChildren: () => import('./features/finalizar-proceso/finalizar-proceso.routes').then(r => r.finalizarProcesoRoutes),
    // canActivate: [securityGuardFn],
    title: 'Finalizar proceso'
  },
  {
    path: 'ingresa',
    loadChildren: () => import('./features/retomar-tramite/retomar-tramite.routes').then(r => r.retomarTramiteRoutes),
    canActivate: [securityGuardFn],
    title: 'Retomar trámite'
  },
  {
    path: 'region-inactiva',
    loadChildren: () => import('./features/region-inactiva-smt/region-inactiva-smt.routes').then(r => r.regionInactivaSmtRoutes),
    canActivate: [securityGuardFn],
    title: 'Región inactiva'
  },
  { path: '**', redirectTo: '' },

];
